import React from 'react';
import { benefits } from '../data/mockData';
import { Maximize2, DoorOpen, ShieldCheck, Target } from 'lucide-react';

const iconMap = {
  'maximize': Maximize2,
  'door-open': DoorOpen,
  'shield-check': ShieldCheck,
  'target': Target
};

const WhyChooseUs = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h3 className="text-[#22C55E] font-semibold text-lg mb-2">
            Why Choose Us?
          </h3>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon];
            return (
              <div 
                key={index}
                className="group text-center p-6 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gray-100 group-hover:bg-[#22C55E] transition-colors duration-300 mb-6">
                  <Icon className="w-10 h-10 text-[#22C55E] group-hover:text-white transition-colors duration-300" />
                </div>
                
                {/* Title */}
                <h4 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-[#22C55E] transition-colors duration-300">
                  {benefit.title}
                </h4>
                
                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Dimensions Section */}
        <div className="mt-20 bg-gray-50 rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-4">Dump Trailer Dimensions</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <span className="text-gray-600">Length</span>
                  <span className="font-bold text-gray-900">14 feet</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <span className="text-gray-600">Width</span>
                  <span className="font-bold text-gray-900">7 feet</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <span className="text-gray-600">Height</span>
                  <span className="font-bold text-gray-900">4 feet</span>
                </div>
                <div className="flex items-center justify-between py-3 border-b border-gray-200">
                  <span className="text-gray-600">Capacity</span>
                  <span className="font-bold text-[#22C55E]">14 Cubic Yards</span>
                </div>
                <div className="flex items-center justify-between py-3">
                  <span className="text-gray-600">Door Opening</span>
                  <span className="font-bold text-gray-900">Ground Level</span>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img 
                src="https://images.pexels.com/photos/35685477/pexels-photo-35685477.jpeg?w=600&h=400&fit=crop"
                alt="Dump Trailer Dimensions"
                className="rounded-xl shadow-lg w-full"
              />
              <div className="absolute -bottom-4 -right-4 bg-[#22C55E] text-white px-6 py-3 rounded-lg shadow-lg">
                <span className="font-bold">14 CU YD</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
